<template>
  <div class="visit-box">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["445"]') }}</span>
      <span slot="secondTit">{{ $t('message["445"]') }}</span>
    </crumb-tit>
    <div
      class="visit-form"
    >
      <div
        v-if="!datasReady"
        class="loading"
      >
        <a-spin tip="loading" />
      </div>
      <a-form
        v-else
        :form="form"
        :class="{'en-form': isEnglish}"
        @submit.prevent="saveForm"
      >
        <a-form-item
          :label="`${firstVisitTitTxt}：`"
        >
          <a-switch
            :checked="!!datas.enablefirst"
            @change="firstSwitch"
          />
          <span class="switch-txt">{{ setSwitchTxt(datas.enablefirst) }}</span>
          <div class="visit-set-f">
            <a-radio-group
              name="radioGroup"
              :value="datas.firstconfig.checked === 'a' ? 1 : 2"
              @change="setFirst"
            >
              <a-radio :value="1">
                {{ $t('message["1223"]') }}<span>
                  <span class="set-input-number">
                    <a-input-number
                      :min="1"
                      :max="840"
                      :value="datas.firstconfig.a * 1 "
                      @change="firstA"
                    />
                    <em>{{ $t('message["304"]') }}</em>
                  </span>
                </span>{{ $t('message["659"]') }}
              </a-radio>
              <a-radio :value="2">
                {{ $t('message["8"]') }}：
                <div class="first-class-time">
                  <ul>
                    <li
                      v-for="(item, index) in firstArr"
                      :key="index"
                    >
                      <first-b-item
                        :item="item"
                        :index="index"
                      />
                    </li>
                  </ul>
                </div>
              </a-radio>
            </a-radio-group>
          </div>
          <div class="date-time-set">
            <a-checkbox
              :checked="datas.firstconfig.is_workday * 1 === 1 "
              @change="timeHandle"
            >
              {{ $t('message["1896"]') }}
              <a-tooltip
                placement="top"
                overlay-class-name="prompt-tooltip2"
              >
                <template slot="title">
                  {{ $t('message["1897"]') }}
                </template>
                <i class="iconfont iconicon-test31" />
              </a-tooltip>
            </a-checkbox>
            <a-form-item>
              <span slot="label">{{ $t('message["1894"]') }}</span>
              <a-radio-group
                name="radioGroup"
                :value="datas.firstconfig.workday_type"
                @change="setWorkDay"
              >
                <a-radio value="c">
                  {{ $t('message["1895"]') }} <a-tooltip
                    placement="top"
                    overlay-class-name="prompt-tooltip2"
                  >
                    <template slot="title">
                      {{ $t('message["1898"]') }}
                    </template>
                    <i class="iconfont iconicon-test31" />
                  </a-tooltip>
                  <div
                    v-if="datas.firstconfig.workday_type === 'c'"
                    class="set-time-box"
                  >
                    <a-time-picker
                      id="c1"
                      :value="$moment(startTime, 'HH:mm')"
                      format="HH:mm"
                      :allow-clear="false"
                      popup-class-name="time-picker-select-pop"
                      @change="onChange"
                    />
                    <span style="margin: 0 12px;">{{ $t('message["1609"]') }}</span>
                    <a-time-picker
                      id="c2"
                      :value="$moment(endTime, 'HH:mm')"
                      :disabled-hours="disHour"
                      :disabled-minutes="disMinutes"
                      :allow-clear="false"
                      popup-class-name="time-picker-select-pop"
                      format="HH:mm"
                      @change="onChange2"
                    />
                  </div>
                </a-radio>
                <a-radio value="d">
                  {{ $t('message["1899"]') }}
                  <div
                    v-if="datas.firstconfig.workday_type === 'd'"
                    class="set-time-box"
                  >
                    <a-time-picker
                      id="d1"
                      :value="$moment(startTime, 'HH:mm')"
                      format="HH:mm"
                      :allow-clear="false"
                      popup-class-name="time-picker-select-pop"
                      @change="onChange"
                    />
                    <span style="margin: 0 12px;">{{ $t('message["1609"]') }}</span>
                    <a-time-picker
                      id="d2"
                      :value="$moment(endTime, 'HH:mm')"
                      :disabled-hours="disHour"
                      :disabled-minutes="disMinutes"
                      format="HH:mm"
                      :allow-clear="false"
                      popup-class-name="time-picker-select-pop"
                      @change="onChange2"
                    />
                    <div class="set-day-box">
                      <a-checkbox-group
                        v-model="datas.firstconfig.d.workday"
                      >
                        <a-checkbox
                          v-for="(val, index ) in days"
                          :key="index"
                          :value="index+1"
                        >
                          {{ val }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </div>
                  </div>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </a-form-item>
        <a-form-item
          :label="visitTitTxt"
        >
          <a-switch
            :checked="!!datas.enablecron"
            @change="cronSwitch"
          />
          <span class="switch-txt">{{ setSwitchTxt(datas.enablecron) }}</span>
          <div class="visit-set-f">
            <div class="visit-radio-c">
              {{ $t('message["440"]') }}<span>
                <span class="set-input-number">
                  <a-input-number
                    :min="1"
                    :max="365"
                    :value="datas.cron_time * 1"
                    @change="setCornTime"
                  />
                  <em>{{ $t('message["1189"]') }}</em>
                </span>
              </span>{{ $t('message["436"]') }}<span>
                <span class="set-input-number">
                  <a-input-number
                    :min="0"
                    :value="datas.cron_noticetime* 1"
                    @change="setcornNoticeTime"
                  />
                  <em>{{ $t('message["1189"]') }}</em>
                </span>
                {{ $t('message["535"]') }}
              </span>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          :label="`${infoTit}：`"
        >
          <a-switch
            :checked="!!datas.enablerecycle"
            @change="setRecycle"
          />
          <span class="switch-txt">{{ setSwitchTxt(datas.enablerecycle) }}</span>
          <div class="visit-set-f">
            <div class="visit-radio-c">
              {{ $t('message["101"]') }}<span>
                <span class="set-input-number">
                  <a-input-number
                    :min="1"
                    :max="1000"
                    :value="datas.recycle_time * 1"
                    @change="setRecycleTime"
                  />
                  <em>{{ $t('message["1189"]') }}</em>
                </span>
              </span> {{ $t('message["435"]') }}
            </div>
          </div>
        </a-form-item>
        <a-form-item>
          <span slot="label">{{ $t('message["993"]') }}</span>
          <a-switch
            :checked="!!datas['is_must_upload']"
            @change="setPic"
          />
          <span class="switch-txt">{{ setSwitchTxt(datas['is_must_upload']) }}</span>
          <div class="visit-set-f">
            <div class="visit-radio-c">
              {{ $t('message["1196"]') }}。
            </div>
          </div>
        </a-form-item>
        <a-form-item>
          <span slot="label"> {{ $t('message["1900"]') }}</span>
          <a-checkbox-group
            v-model="checkeFieldsKeys"
            @change="setFields"
          >
            <a-checkbox
              v-for="(val, key ) in datas.firstconfig.addfields"
              :key="key"
              :value="key"
              :disabled="!val.isenable"
            >
              {{ val.fieldname }}
              <template v-if="!val.isenable">
                <a-tooltip
                  placement="top"
                  overlay-class-name="prompt-tooltip2"
                >
                  <template slot="title">
                    {{ $t('message["1901"]') }}
                  </template>
                  <i class="iconfont iconicon-test31" />
                </a-tooltip>
              </template>
            </a-checkbox>
          </a-checkbox-group>
          <div class="visit-set-f">
            <div class="visit-radio-c">
              {{ $t('message["1902"]') }}
            </div>
          </div>
        </a-form-item>
        <!-- <a-form-item
          class="submit-btn"
          label=""
        >
          <a-button
            type="primary"
            html-type="submit"
          >
            保存
          </a-button>
        </a-form-item> -->
        <div
          ref="footerBtn"
          class="footer-wrap"
        >
          <div
            ref="footer"
            class="footer"
            :class="{'ani':isShowBtn}"
          >
            <a-button
              type="primary"
              html-type="submit"
              :loading="submitting"
            >
              {{ $t('message["21"]') }}
            </a-button>
            <span class="sub-tip">{{ $t('message["22"]') }}？</span>
          </div>
        </div>
      </a-form>
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import FirstBItem from './visit/FirstBItem'
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  components: {
    FirstBItem,
    CrumbTit
  },
  data () {
    return {
      submitting: false,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      },
      isShowBtn: false,
      counter: 1,
      startTime: '08:00',
      endTime: '18:00',
      checkeFieldsKeys: []
    }
  },
  computed: {
    ...mapState('config/visit', ['datas', 'datasReady']),
    isHideConfig () {
      return this.$store.getters.roleid !== 6
    },
    mainForm () {
      return this.datas
    },
    projectName () {
      return this.$store.getters.baseinfo.projectname
    },
    firstArr () {
      return Object.keys(this.datas.firstconfig.b)
    },
    visitTitTxt () {
      return this.$t('message["243"]')
    },
    visitbackTitTxt () {
      return this.$t('message["441"]')
    },
    firstVisitTitTxt () {
      return this.$t('message["1119"]')
    },
    infoTit () {
      return this.$t('message["1367"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    limitTime () {
      let arr = this.startTime.split(':')
      let arrH = []
      let arrMinutes = []
      let arrSeconds = []
      for (let i = 0; i < arr[0]; i++) {
        arrH.push(i)
      }
      for (let j = 0; j < arr[1]; j++) {
        arrMinutes.push(j)
      }
      for (let k = 0; k < arr[2]; k++) {
        arrSeconds.push(k)
      }
      return {
        disH: arrH,
        disM: arrMinutes,
        disS: arrSeconds
      }
    },
    days () {
      const arr = this.$t('message["1628"]').split(',')
      const first = arr.splice(0, 1)
      return arr.concat(first)
    },
    workType () {
      return this.datas.firstconfig.workday_type
    },
    time () {
      return this.datas.firstconfig[this.workType].sendperiod
    }
  },
  watch: {
    datasReady (val) {
      if (val) {
        this.setFooterStyle()
      }
    },
    datas: {
      handler (val) {
        this.checkeFieldsKeys = this.filedkeysChecked()
        this.counter++
        if (val && this.counter > 2) {
          this.isShowBtn = true
          this.setFooterStyle()
          // this.$refs.footerBtn.style.height = '64px'
        }
      },
      deep: true
    }
  },
  inject: ['reload'],
  async mounted () {
    // this.reload()
    const chain = await this.fetchDatas()
    chain.params({ type: 4 })
      .onSuccess(() => {
        document.title = this.$t('message["445"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        const { time } = this
        if (time.length > 0) {
          this.startTime = time[0]
          this.endTime = time[1]
        }
      })
      .fetch()
  },
  created () {
    this.form = this.$form.createForm(this)

    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
  },
  methods: {
    ...mapActions('config/visit', ['fetchDatas', 'subVisit']),
    getLang,
    async saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.submitting = true
          const chain = await this.subVisit()
          chain.params(this.datas)
            .onSuccess(async () => {
              this.$message.success(this.$t('message["446"]'))
              this.reload()
            })
            .onNetSuccess((res) => {
              this.submitting = false
            })
            .fetch()
        }
      })
    },
    firstSwitch (e) {
      this.datas.enablefirst = e ? 1 : 0
    },
    cronSwitch (e) {
      this.datas.enablecron = e ? 1 : 0
    },
    setSwitchTxt (b) {
      const a = b ? this.$t('message["1466"]') : this.$t('message["1459"]')
      return a
    },
    setWorkDay (val) {
      this.datas.firstconfig.workday_type = val.target.value
      this.startTime = this.time[0]
      this.endTime = this.time[1]
    },
    setFirst (val) {
      this.datas.firstconfig.checked = val.target.value === 1 ? 'a' : 'b'
    },
    firstA (e) {
      this.datas.firstconfig.a = e
    },
    setCornTime (e) {
      this.datas.cron_time = e
    },
    setcornNoticeTime (e) {
      this.datas.cron_noticetime = e
    },
    setRecycle (e) {
      this.datas.enablerecycle = e ? 1 : 0
    },
    setPic (e) {
      this.datas['is_must_upload'] = e ? 1 : 0
    },
    setRecycleTime (e) {
      this.datas.recycle_time = e
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    },
    timeHandle (val) {
      this.datas.firstconfig.is_workday = val.target.checked ? 1 : 0
    },
    onChange (time, timeString) {
      this.startTime = timeString || '08:00'
      this.$set(this.datas.firstconfig[this.workType].sendperiod, 0, this.startTime)
    },
    onChange2 (time, timeString) {
      this.endTime = timeString || '18:00'
      this.$set(this.datas.firstconfig[this.workType].sendperiod, 1, this.endTime)
    },
    disHour () {
      return this.limitTime.disH
    },
    disMinutes (h) {
      const disH = this.startTime.split(':')
      if (h < disH[0] * 1 || (h === disH[0] * 1)) {
        return this.limitTime.disM
      } else {
        return []
      }
    },
    filedkeysChecked () {
      let arr = []
      const { addfields = {} } = this.datas.firstconfig
      const filedkeys = Object.keys(addfields)
      const arrValues = Object.values(addfields)
      for (let i = 0; i < arrValues.length; i++) {
        const item = arrValues[i]
        if (item.checked) {
          arr.push(filedkeys[i])
        }
      }
      return arr
    },
    setFields (val) {
      // const { filedkeysChecked } = this
      let fields = this.datas.firstconfig.addfields
      for (let key in fields) {
        fields[key].checked = val.includes(key) ? 1 : 0
      }
    }
  }
}
</script>
<style lang="scss" scoped >
.visit-form::v-deep {
  padding: 24px 0 0;
  line-height: 32px;
  .visit-set-f{
    .ant-radio-wrapper {
      display: block !important;
      padding: 14px 0;
      span.ant-radio + * {
        padding-left: 2px;
      }
    }
    .visit-radio-c {
      margin: 12px 0 30px;
    }
  }
  .date-time-set {
    border-top: 1px solid #ebebeb;
    padding-top: 24px;
    margin-top: -30px;
    line-height: 32px;
     .ant-form-item{
       margin-bottom: 0;
     }
    .ant-form-item label {
      line-height: 32px;
    }
    .ant-form-item .ant-radio-wrapper {
      display: block;
      margin-bottom: -10px;
      &.ant-radio-wrapper:nth-child(2).ant-radio-wrapper-checked{
        margin-top: 16px;
      }
    }
    .ant-form-item-children {
      line-height: 0;
    }
  }
  .set-day-box {
    margin-top: 16px;
  }
  .set-time-box{
    margin:16px 0 0 28px;
  }
  .iconicon-test31 {
    color: #d6d6d6
  }
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 100px;
    .ant-input-number{
      width:160px;
    }
    .ant-checkbox-group {
      .ant-checkbox-wrapper {
        margin-bottom: 0;
      }
    }
    .ant-form-item-label {
      float: left;
      width: 80px;
      margin-left: -80px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
    .switch-txt {
      margin-left: 12px;
    }
    .first-class-time {
      line-height: 32px;
      margin: 20px 0 0 50px;
      li {
        margin-bottom: 16px;
        strong {
          display: inline-block;
          width: 40px;
          text-align: right;
        }
      }
    }
    .set-input-number {
      display: inline-block;
      width: 160px;
      height: 32px;
      line-height: 32px;
      position: relative;
      margin: 0 12px;
      em {
          position: absolute;
          right: 36px;
          font-style: normal;
          top: 2px;
        }
    }
  }
  .footer-wrap {
    height: 64px;
    margin-top: 40px;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    z-index: 999;
    height: 64px;
    margin-left: -40px;
    padding: 16px 120px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
     .ant-btn {
        margin-right: 0 ;
      }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
    // transform: translateY(100%)
  opacity: 0;
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
}
.en-form::v-deep {
  .ant-row {
    padding-left: 160px;
    .ant-input-number{
      width:160px;
    }
    .ant-form-item-label {
      float: left;
      width: 140px;
      margin-left: -160px;
      label {
      color: #666;
      }
    }
    .first-class-time {
      margin-left: 0 !important;
      li strong {
        width: 80px !important;
      }
    }
  }
}
</style>
<style lang="scss">
.time-picker-select-pop {
   .ant-time-picker-panel-clear-btn {
    display: none
  }
}
</style>
